<!------------- Tarifa Línea Pack ------------->
<!--------------------------------------------->

<form [formGroup]="secondFormGroup">

    <app-rate [access]="rateAccess" [realtechnology]="realtechnology" [listener]="this" [showMobilePromo]="showMobilePromo" *ngIf="rate === null"></app-rate>

    <div class="container content" *ngIf="rate">
        <div class="row">
            <div class="col-lg-12">
                <h5 class="title-step" align="center">
                    <img src="./assets/img/package.svg" class="img-fluid ico-title" width="20">
                    {{ index == 0 ? 'Tarifa ' + (router === '/amena/solo_movil' ? 'línea móvil principal' : 'fijo y móvil') : 'Tarifa ' + (index + 1) + 'º línea móvil' }}

                    <span class="rate-edit" (click)="editRate()">
                        <fa-icon matDatepickerToggleIcon [icon]="faPen"></fa-icon>
                        Cambiar tarifa
                    </span>
                </h5>
                <div class="card card-default card-horizontal mb-5">
                    <div class="card-heading background-grey">
                        <div class="row">
                            <div class="col-lg-6">
                                <h5 align="left" class="tar-name car-tar-1 my-3">{{ rate.name }}</h5>
                            </div>
                            <div class="col-lg-6 my-auto">
                                <h5 align="left" class="tar-price car-tar-2 my-3">
                                    {{ rate.price.split('.')[0] }}<span>,{{ rate.price.split('.')[1] }}€/mes</span>
                                </h5>
                            </div>
                        </div>
                    </div>

                    <div class="card-body">
                        <div class="row">
                            <div class="col-md-6 d-flex flex-column justify-content-center">
                                <h5 align="left" class="tar-name-5 my-0" *ngIf="!thereIsOffer(rate, 'data')">
                                    <b>{{ rate.data }}</b> de navegación
                                </h5>
                                <h5 align="left" class="tar-name-5 my-0" *ngIf="thereIsOffer(rate, 'data')">
                                    <b>{{ rate?.offers[0]?.data }}</b> de navegación
                                </h5>

                                <h5 align="left" class="tar-name-5 my-0" *ngIf="rate.speed && rate.speed !== ''">
                                    <b>{{ rate.speed }}</b>
                                </h5>
                                <h5 align="left" class="tar-name-5 my-0" *ngIf="rate.extra_info_1 && rate.extra_info_1 != ''">
                                    <b class="line-break">{{ rate.extra_info_1 }}</b>
                                </h5>
                            </div>
                            <div class="col-md-auto"><span class="vl mobile"></span></div>
                            <div class="col-md-5  d-flex flex-column justify-content-center">
                                <h5 align="left" class="tar-name-5 my-0"
                                    *ngIf="rate.voice && rate.voice != ''">
                                    <b>{{ rate.voice }}</b>
                                </h5>
                                <h5 align="left" class="tar-name-5 my-0"
                                    *ngIf="rate.sms && rate.sms != '' && rate.type === 'mobile'">
                                    <b>{{ rate.sms }}</b>
                                </h5>
                                <h5 align="left" class="tar-name-5 my-0"
                                    *ngIf="rate.extra_info_2 && rate.extra_info_2 != ''">
                                    <b class="line-break">{{ rate.extra_info_2 }}</b>
                                </h5>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>

    <!--------- Activación Línea Pack ----------->
    <!------------------------------------------->
    <div class="container content" *ngIf="rate">
        <div class="row mb-2">
            <div class="col-lg-12">
                <h5 class="title-step" align="center">
                    <img src="./assets/img/smartphone.svg" class="img-fluid ico-title" width="20">
                    Tipo de operación línea móvil
                    <!--Configuración de {{ index == 0 ? ' línea móvil ' + (router === '/amena/solo_movil' ? 'principal' : 'pack') : (index + 1) + 'º línea móvil' }}-->
                </h5>
                <div class="card">
                    <div class="container color-card">
                        <div>
                            <!----- Tipo de operación ------->
                            <div class="radio-btn-group row" ngbRadioGroup name="typeOperation"
                                    formControlName="type_operation"
                                    (change)="changeTypeOperation();" [(ngModel)]="typeOperation">
                                <div class="operacion-movil col-lg-6 add-padding-card" *ngIf="typeOperation !== 'migration' && (pdv && pdv.info.telesales !== 1) && !isAmenaEnCasa">
                                    <h6 class="subtitulo-pack">Tipo de operación: </h6>

                                    <div class="radio radio-pack">
                                        <label ngbButtonLabel>
                                            <input ngbButton type="radio" value="registration"
                                                    [checked]="typeOperation == 'registration'"/>
                                            Alta nueva
                                        </label>
                                    </div>

                                    <div class="radio radio-pack">
                                        <label ngbButtonLabel>
                                            <input ngbButton type="radio" value="portability"
                                                    [checked]="typeOperation == 'portability'"/>
                                            Portabilidad
                                        </label>
                                    </div>
                                </div>

                                <div class="operacion-movil col-lg-6 themed-grid-col bg-white add-padding-card" *ngIf="typeOperation !== 'migration'" [ngClass]="{'bg-white' : pdv && pdv.info.telesales !== 1 && !isAmenaEnCasa }">
                                    <h6 class="subtitulo-pack">{{ ((pdv && pdv.info.telesales === 1) || isAmenaEnCasa) ? 'Tipo de operación: ' : 'Con terminal: ' }}</h6>
                                    <div class="radio radio-pack">
                                        <label ngbButtonLabel>
                                            <input ngbButton type="radio" value="registration_logistica"
                                                    [checked]="typeOperation == 'registration_logistica'"/>
                                            Alta nueva
                                        </label>
                                    </div>

                                    <div class="radio radio-pack" *ngIf="!isAmenaEnCasa">
                                        <label ngbButtonLabel>
                                            <input ngbButton type="radio" value="portability_logistica"
                                                    [checked]="typeOperation == 'portability_logistica'"/>
                                            Portabilidad
                                        </label>
                                    </div>
                                </div>

                                <div class="operacion-movil add-padding-card" *ngIf="typeOperation === 'migration'">
                                    <h6 class="subtitulo-pack">Tipo de operación: </h6>
                                    <div class="radio radio-pack">
                                        <label ngbButtonLabel>
                                            <input ngbButton type="radio" value="migration"
                                                    [checked]="typeOperation == 'migration'"/>
                                            Migración
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <ul class="list-group list-group-flush">
                        <li class="list-group-item cuerpo-pack" [ngClass]="{'delete-padding' : typeOperation === 'registration_logistica' || isAmenaEnCasa }">
                            <ng-container *ngIf="typeOperation === 'migration'">
                                <h6 class="subtitulo-pack-form">
                                    Datos de la migración
                                </h6>

                                <div class="form-row">
                                    <div class="col-lg-3 mt-1">
                                        <mat-form-field>
                                            <mat-label>Teléfono móvil a migrar</mat-label>
                                            <input type="text" matInput formControlName="portability_phone" maxlength="9">
                                            <mat-error *ngIf="secondFormGroup.get('portability_phone')?.errors?.isRepeat">
                                                MSISDN ya utilizado en este flujo
                                            </mat-error>
                                        </mat-form-field>
                                    </div>
                                </div>
                            </ng-container>
                            <ng-container *ngIf="typeOperation !== 'migration'">
                                <h6 class="subtitulo-pack-form" *ngIf="typeOperation == 'portability' || typeOperation == 'portability_logistica'">
                                    Datos de alta / portabilidad
                                </h6>

                                <div class="form-row" *ngIf="typeOperation == 'portability' || typeOperation == 'portability_logistica'">
                                    <div class="col-lg-3 mt-1">
                                        <mat-form-field>
                                            <mat-label>Teléfono móvil a portar</mat-label>
                                            <input type="text" matInput formControlName="portability_phone" maxlength="9">
                                            <mat-error *ngIf="secondFormGroup.get('portability_phone')?.errors?.isRepeat">
                                                MSISDN ya utilizado en este flujo
                                            </mat-error>
                                        </mat-form-field>
                                    </div>

                                    <div class="col-lg-2 mt-1">
                                        <mat-form-field>
                                            <mat-label>Operador donante</mat-label>

                                            <select matNativeControl formControlName="portability_operator">
                                                <option *ngFor="let provider of providers" [value]="provider.service_provider_id">{{ provider.name }}</option>
                                            </select>
                                        </mat-form-field>
                                    </div>

                                    <div class="col-lg-3 mt-1">
                                        <mat-form-field>
                                            <mat-label>Tipo de cliente donante</mat-label>
                                            <select matNativeControl formControlName="portability_type_client"
                                                    (change)="changePortabilityTypeClient($event.target.value)">
                                                <option [value]="'postpaid'" [selected]="portability_type_client === 'postpaid'">Contrato</option>
                                                <option [value]="'prepaid'" [selected]="portability_type_client === 'prepaid'">Prepago</option>
                                            </select>
                                        </mat-form-field>
                                    </div>

                                    <div class="col-lg-4 mt-1" *ngIf="secondFormGroup.get('portability_type_client').value === 'prepaid'">
                                        <mat-form-field>
                                            <mat-label>ICCID donante</mat-label>
                                            <input type="text" matInput formControlName="portability_iccid" maxlength="19" minlength="19">
                                            <mat-hint align="end">{{ secondFormGroup.get('portability_iccid').value.length }} / 19</mat-hint>
                                            <mat-error *ngIf="secondFormGroup.get('portability_iccid')?.errors?.isRepeat">
                                                ICCID ya utilizado en este flujo
                                            </mat-error>
                                        </mat-form-field>
                                    </div>
                                </div>

                                <div *ngIf="(typeOperation === 'registration' || typeOperation === 'portability') && !isAmenaEnCasa && pdv && pdv.info.telesales !== 1">
                                    <h6 class="subtitulo-pack-form">Datos SIM en Amena</h6>
                                    <div class="form-row">
                                        <div class="col-lg-5 mb-0">
                                            <mat-form-field>
                                                <mat-label>ICCID entregado al cliente</mat-label>
                                                <input type="text" matInput formControlName="iccid" maxlength="19" (focus)="addPrefix()" maxlength="19" minlength="19">
                                                <mat-hint align="end">{{ secondFormGroup.get('iccid').value.length }} / 19</mat-hint>
                                                <mat-error *ngIf="secondFormGroup.get('iccid')?.errors?.isRepeat">
                                                    ICCID ya utilizado en este flujo
                                                </mat-error>
                                            </mat-form-field>
                                        </div>
                                        <a class="cursor-pointer d-flex" (click)="openModalICCID(ICCID)" title="¿Dónde encuentro el ICCID?">
                                            <img src="./assets/img/info.svg" class="img-fluid ico-title icon-white" width="20">
                                        </a>
                                    </div>
                                </div>
                            </ng-container>
                        </li>
                    </ul>
                </div>
            </div>
        </div>

        <div class="row terminal-row" *ngIf="pdv && pdv.permissions.AMENA_VENTA_DE_TERMINALES === 'PERMITE_LA_VENTA_DE_TERMINALES' && (typeOperation === 'registration_logistica' || typeOperation === 'portability_logistica') || isAmenaEnCasa">
            <div class="col-lg-12">
                <h5 class="title-step" align="center">
                    <img src="./assets/img/smartphone.svg" class="img-fluid ico-title" width="20">
                    Selección de terminal
                </h5>
                <div class="card">
                    <ul class="list-group list-group-flush">
                        <li class="list-group-item cuerpo-pack">
                            <div class="form-row">
                                <div class="col-lg-7 mb-0">
                                    <app-terminal #terminal [listener]="this" [typeOperation]="typeOperation" [isAmenaEnCasa]="isAmenaEnCasa"></app-terminal>
                                </div>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
        </div>

        <!-- bloque línea adicional -->
        <div class="jumbotron-ad amena mt-3" *ngIf="amenaListener.isAvailableToAdd()">
            <div class="d-flex justify-content-between align-items-center">
                <div>
                    <span class="ad-text">¿Deseas añadir <b>una línea de móvil adicional</b>?</span>
                </div>
                <small class="text-muted btn-muted">
                    <button class="btn btn-black btn-sm" (click)="addNewLine()">
                        Contratar <span class="mobile">línea de móvil adicional</span>
                    </button>
                </small>
            </div>
        </div>


        <!-- Continuar proceso -->
        <div align="center">
            <br>
            <button class="btn btn-black-outline btn-block mb-1" (click)="validate()">
                Continuar
                <img src="./assets/img/arrow-right.svg" class="img-fluid ico-title" width="15">
            </button>
            <button class="btn btn-grey-outline2 btn-block mb-5" role="button" (click)="back()">
                Volver
            </button>
            <br><br>
        </div>
    </div>
</form>

<ng-template #ICCID let-modal>
    <div class="modal-header bg-simyo-grey">
        <h5 class="modal-title white" id="exampleModalLabel">¿Dónde encuentro el ICCID?</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="modal.dismiss()">
            <span aria-hidden="true">
                <img src="./assets/img/times2.svg" class="img-fluid ico-title" width="20">
            </span>
        </button>
    </div>
    <img src="./assets/img/amena_iccid.png" class="img-fluid ico-title p-5">
</ng-template>